document.querySelectorAll('.info-items__cat__hidden-toggle').forEach(function(toggle) {
  toggle.addEventListener('click', function() {
    var target = this.nextElementSibling;

    if (target.style.display === 'block' || target.style.display === '') {
      target.style.display = 'none';
    } else {
      target.style.display = 'block';
    }
  });
});
